var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbars',{attrs:{"messages":_vm.intenalMessages,"color":"red","top":"","right":""},on:{"update:messages":function($event){_vm.intenalMessages=$event}},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var close = ref.close;
return [_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return close()}}},[_vm._v("CHIUDI")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }